import { render, staticRenderFns } from "./restore.vue?vue&type=template&id=57b6ca1d&scoped=true&"
import script from "./restore.vue?vue&type=script&lang=js&"
export * from "./restore.vue?vue&type=script&lang=js&"
import style0 from "./restore.vue?vue&type=style&index=0&id=57b6ca1d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b6ca1d",
  null
  
)

export default component.exports